<form [formGroup]="loginForm" class="login-container">
  <div>
    <div class="superheader">
      Welcome to LandYield
      <sup>®</sup>
    </div>
    <div class="header">Log Into Your Account</div>
  </div>
  <mat-form-field class="w-100-1">
    <mat-label>Email</mat-label>
    <input formControlName="email" matInput required type="email" />
    @if (loginEmailErrorMessage) {
      <mat-error data-cy="email-validation-error">
        {{ loginEmailErrorMessage }}
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field class="w-100-1">
    <mat-label>Password</mat-label>
    <input [type]="showPassword ? 'text' : 'password'" formControlName="password" matInput required />
    <mat-icon (click)="showPassword = !showPassword" class="password-visibility" matSuffix>
      @if (showPassword) {
        <fa-icon [icon]="['fas', 'eye-slash']" class="dark-gray"></fa-icon>
      } @else {
        <fa-icon [icon]="['fas', 'eye']" class="dark-gray"></fa-icon>
      }
    </mat-icon>
  </mat-form-field>
  @if (loginError || showResend || showResendSent) {
    <div class="message">
      <div class="error">
        @if (!showResendSent) {
          @if (!showResend) {
            {{ errorMessage || 'Invalid username or password' }}
          } @else {
            Your temporary password has expired. Please contact us at {{ helpPhone }} or via email at
            <a [href]="'mailto:' + helpEmail" rel="noopener noreferrer" target="_blank">
              {{ helpEmail }}
            </a>
            .
          }
        } @else {
          @if (!showResend) {
            Your invitation email has been resent.
          }
        }
      </div>
    </div>
  }
  <div class="space-between-container">
    <div (click)="authMode = authModeEnum.forgotPassword" class="fc-link forgot">Forgot Password</div>
    <button (click)="login()" [disabled]="!loginForm.valid" color="primary" data-cy="log-in-button" mat-raised-button>
      Log In
    </button>
  </div>
</form>
